import { Stack as MatchboxStack } from '@sparkpost/matchbox';

/**
 * Matchbox Stack component.
 * @see https://design.sparkpost.com/components/stack/
 */
const Stack = MatchboxStack;

export default Stack;
